<template>
    <div>
        <b-overlay :show="isBusy" rounded="sm" opacity="0.50 " variant="white">
            <b-container class="bv-example-row mb-3">
                <b-row>
                    <b-col class="text-right" >
                        <i class="ti-close pointer font-weight-bold" @click="$emit('Choisir-Structure-Cancel')"></i>
                    </b-col>
                </b-row>
                <b-row>
                    <b-col >
                        <h4>Choisir une Structure / un Rôle :</h4>
                    </b-col>
                </b-row>
            </b-container>
            
        <div class="table-overflow overflow-auto">
            <table>
                <tr  v-for="struct in structures" v-bind:key="struct.id" >
                    <td  class="align-middle text-center" > {{struct.name}}</td>
                    <td v-for="role in  struct.list_roles" v-bind:key="role.id" class="col-3 align-middle">  
                        
                        <button class="btn pointer m-auto mb-2"
                        :class="struct.id==$store.getters.structure_id&&role.role_id==1? 'btn-primary disabled' : 'btn-default classHover'" 
                        :disabled="struct.id==$store.getters.structure_id&&role.role_id==1? true : false"
                        @click="Choisir(struct,role)"> 
                            <span v-if="role.role_id==1" > Responsable </span>
                            <span v-if="role.role_id==2"> - </span>
                            <span v-if="role.role_id==3" class="bg-default" title="Vous allez être redirigé vers le site Adhérent"> Adhérent(e) </span>
                            <span v-if="role.role_id==4"> Salarié </span>
                            <span v-if="role.role_id==5"> {{struct.id}} </span>
                        </button>

                    </td>
                </tr>
            </table>
        </div>

    <!--    <b-list-group v-for="struct in structures" v-bind:key="struct.id" class="m-auto">
           
            <b-list-group-item 
                                :active="struct.id==$store.getters.structure_id? true : false" 
                                :disabled="struct.id==$store.getters.structure_id? true : false" 
                                class="text-center mb-2 classHover" 
                                @click="Choisir(struct)"> 
                                 {{struct.name}}
                                     <span v-if="struct.pivot.role_id==1"> Responsable </span>
                                    <span v-if="struct.pivot.role_id==3"> Adhérent(e </span>
            </b-list-group-item>
            </b-list-group> -->

         </b-overlay>
    </div>
</template>
<script>

    import api from "../config/_api";
    
    import { mapGetters } from 'vuex';
    
    import {AUTH_LOGOUT,AUTH_REQUEST} from '../store/actions/auth';
    
    import {STRUCTURE_CHANGE} from '../store/actions/user';
    
    import sha1 from 'sha1';

    export default {
        name : "ChoisirStructure",
        data(){
            return{
                isBusy:false,
            }
        },
        props : {
            structures : {
                required: false,
            },
            email : {
                required: true,
            },
            token : {
                required: true,
            }

        },
        methods : {
            Choisir (struct,role){

                this.structure_name=struct.name;
                this.isBusy=true;
                setTimeout(function () {
                    this.$store.dispatch(STRUCTURE_CHANGE,struct).then(function (){
                        if((role.role_id==1)||(role.role_id=5)||(role.role_id=2)){
                            this.$store.dispatch('systems/getSystems');
                            this.$store.dispatch('structure/getStructure');
                            this.$store.dispatch('adherents/getUtilisateurs');
                            this.$store.dispatch('sensors/getSensors');
                            this.$store.dispatch('extractions/getExtractions');
                            setTimeout(() => { 
                                this.isBusy=false; 
                                this.$emit('Choisir-Structure-done',struct); 
                            },1000);
                        }
                        else{
                            //On ne doit pas faire de logout pour pouvoir passer au site adhérent les infos dont il a besoin pour login auto
                            this.$store.dispatch(AUTH_LOGOUT).then( () =>{
                                //window.location="https://appudev.kemtag.fr/";
                                this.isBusy=false;
                                this.$emit('Choisir-Structure-done',struct);
                                
                                setTimeout(function () {
                                    if(this.$props.token!= null && this.$props.token != ""){
                                        this.$router.push("/redirect/Adherent/"+this.$props.token+"/"+this.$props.email+"/"+struct.id+"/"+role.role_id); 
                                    }
                                    else{
                                        this.$router.push("/redirect/Adherent/"); 
                                    } 
                                }.bind(this,struct,role),800);
                            }); 
                            /*setTimeout(() => {
                                this.$router.push("/redirect/Adherent"); 
                            },800);*/
                        }
                    }.bind(this,struct,role)); 
                }.bind(this,struct,role), 1000);
            },
        }
    }
</script>
<style scoped>
.classHover:hover {
  background-color: rgba(200, 217, 255, 0.68);
}
td {
    padding-bottom : 15px;
    
    padding-top : 15px
}
</style>